var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
import { Icon } from '../Icon/index.js';
import { ExclamationCircleIcon } from '../icons/index.js';
export const Input = forwardRef((props, ref) => {
    const { invalid = false, disabled, leadingIcon, trailingIcon, leadingAddon, trailingAddon, className, wrapperClassName } = props, rest = __rest(props, ["invalid", "disabled", "leadingIcon", "trailingIcon", "leadingAddon", "trailingAddon", "className", "wrapperClassName"]);
    const { backgroundType } = useBackgroundContext();
    const mainClsx = [
        'placeholder-basicSurface-300/75',
        !invalid &&
            'focus:ring-actionPrimary-500 focus:border-actionPrimary-500 border border-basicSurface-300/25',
    ];
    const surfaceClsx = [
        'placeholder-basicSurface-300/75',
        !invalid &&
            'focus:ring-actionPrimary-500 focus:border-actionPrimary-500 border border-basicSurface-300/25',
    ];
    const secondaryClsx = [
        'placeholder-basicSecondary-300/50',
        !invalid &&
            'focus:ring-actionSecondary-600 focus:border-actionSecondary-600 border border-basicSecondary-300/25',
    ];
    const iconClsx = [
        backgroundType === 'main' && 'text-basicSurface-400',
        backgroundType === 'surface' && 'text-basicSurface-400',
        backgroundType === 'secondary' && 'text-basicSecondary-400',
    ];
    const backgroundClsx = [
        backgroundType === 'main' && 'bg-surface-50 text-basicSurface-500',
        backgroundType === 'surface' && 'bg-surface-50 text-basicSurface-500',
        backgroundType === 'secondary' &&
            'bg-actionSecondary-50 text-basicSecondary-500',
    ];
    return (React.createElement("div", { className: clsx('flex relative rounded-md shadow-sm isolate w-full', wrapperClassName) },
        React.createElement("div", { className: "flex items-stretch flex-grow focus-within:z-10" },
            leadingIcon && (React.createElement("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" },
                React.createElement(Icon, { className: clsx('h-5 w-5', iconClsx) }, leadingIcon))),
            leadingAddon && (React.createElement("span", { className: clsx('inline-flex items-center px-3 rounded-l-md border border-r-0 border-basicSurface-300/25', backgroundClsx) }, leadingAddon)),
            React.createElement("input", Object.assign({ ref: ref, className: clsx('block w-full rounded-md', 'px-3 py-2', 'appearance-none', 'focus:outline-none focus:ring-1', backgroundClsx, [
                    backgroundType === 'main' && mainClsx,
                    backgroundType === 'surface' && surfaceClsx,
                    backgroundType === 'secondary' && secondaryClsx,
                ], invalid &&
                    'pr-10 border-danger-300 text-danger-900 placeholder-danger-300 focus:outline-none focus:ring-danger-500 focus:border-danger-500', disabled && 'opacity-60 cursor-default', leadingIcon && 'pl-10', trailingIcon && 'pr-10 ', leadingAddon &&
                    'flex-1 min-w-0 block w-full px-3 py-2 rounded-l-none', leadingAddon && !trailingAddon && 'rounded-r-md', trailingAddon &&
                    'flex-1 min-w-0 block w-full px-3 py-2 rounded-r-none', trailingAddon && !leadingAddon && 'rounded-l-md', className), type: "text", disabled: disabled }, rest))),
        trailingIcon && (React.createElement("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none z-10" },
            React.createElement(Icon, { className: clsx('h-5 w-5', iconClsx) }, trailingIcon))),
        trailingAddon && (React.createElement("span", { className: clsx('inline-flex items-center px-3 rounded-r-md border border-l-0 border-basicSurface-300/25', backgroundClsx) }, trailingAddon)),
        invalid && (React.createElement("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none z-10" },
            React.createElement(ExclamationCircleIcon, { className: "h-5 w-5 text-danger-500", "aria-hidden": "true" })))));
});
//# sourceMappingURL=Input.js.map